var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.648 2.245a.833.833 0 0 0-1.18 0L4.862 7.852c-.26.26-.26.68 0 .94l5.606 5.606a.833.833 0 0 0 1.18 0 .833.833 0 0 0 0-1.18L6.755 8.325l4.9-4.9a.84.84 0 0 0-.007-1.18"
  })));
};
export default SvgChevronLeft;